import type { BariPostNurseSpecialistFollowUpDataV2 } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/v2/bariPostNurseSpecialistFollowUpDataV2';
import { initialData } from '../bariPostNurseSpecialistFollowUpDataBase';

export const initialDataV2: BariPostNurseSpecialistFollowUpDataV2 = {
    ...initialData,
    adjuvante_gewichtsreducerende_medicatie: null,
    adjuvante_gewichtsreducerende_medicatie_startdatum: null,
    adjuvante_gewichtsreducerende_medicatie_stopdatum: null,
    depressie_status: null,
    diabetes_mellitus_medicamenteuze_veranderingen: null,
    dyslipidemie_medicamenteuze_veranderingen: null,
    gastroesophageal_reflux_disease_medicamenteuze_veranderingen: null,
    gewrichtsklachten_therapeutische_veranderingen: null,
    hypertensie_medicamenteuze_veranderingen: null,
    longziekte_status: null,
    osas_therapeutische_veranderingen: null,
    start_adjuvante_gewichtsreducerende_medicatie: null,
    tabak_gebruik: null,
    tabak_toelichting: null,
    toelichting_deficienties_labuitslag: null,
};
